export default "__VITE_ASSET__CYObombv__"